import axios from "../axiosClient";

export const getAssets = async (
  pageNumber: any,
  pageSize: any,
  tcCode: any,
  siteCode: any,
  blockCode: any,
  isActive: any,
  status: any,
  assetTypeId: any,
  sortBy: any,
  sortDirection: any,
  searchText: any,
  signal: any,
  isInFloorPlan?: any
) => {
  const res = await axios.get(`/slpapp/Asset/getall`, {
    params: {
      pageNumber,
      pageSize,
      tcCode,
      siteCode,
      blockCode,
      isActive,
      status,
      assetTypeId,
      searchText,
      sortBy,
      sortDirection,
      isInFloorPlan: isInFloorPlan,
    },
    signal,
  });

  return res?.data;
};

export const getGatewaySummary = async (
  tcCode: any,
  siteCode: any,
  blockCode: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/TC/getLocationGatewaySummary`, {
    params: { tcCode, siteCode, blockCode },
    signal,
  });

  return res?.data?.data;
};

export const getLightSummary = async (
  tcCode: any,
  siteCode: any,
  blockCode: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/TC/getLocationLightSummary`, {
    params: { tcCode, siteCode, blockCode },
    signal,
  });

  return res?.data?.data;
};

export const getLastDaylightReadingByAsset = async (
  assetCode: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Asset/LastDaylightReadingByAsset`, {
    params: { assetCode },
    signal,
  });

  return res?.data;
};

export const getLastMotionReadingByAsset = async (
  assetCode: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Asset/LastMotionReadingByAsset`, {
    params: { assetCode },
    signal,
  });

  return res?.data;
};

export const getLastStatusReadingByAsset = async (
  assetCode: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Asset/LastStatusReadingByAsset`, {
    params: { assetCode },
    signal,
  });

  return res?.data;
};

export const getSiteSummaryForBlocks = async (
  PageNumber: any,
  pageSize: any,
  tcCode: any,
  siteCode: any,
  siteProjectTypeId: any,
  SortBy: any,
  SortDirection: any,
  signal: any
) => {
  const res = await axios.post(
    `/slpapp/Site/getSiteSummary`,
    {
      PageNumber,
      pageSize,
      tcCode,
      siteCode,
      siteProjectTypeId,
      SortBy,
      SortDirection,
    },
    { signal }
  );

  return res?.data;
};
